import BaseApi from './base/BaseApi';

export default class CrmFunnelApi extends BaseApi {
  static entityName = 'crm_funnels';
}
